module.exports = __webpack_public_path__ + "static/media/Combined Shape Copy 6@1.5x.fd5ee431.svg";